import gql from 'graphql-tag'

export const LOGIN_MUTATION = gql`
    mutation loginMutation(
        $email: String!
        $password: String!
        $remember: Boolean
    ) {
        login(
            input: { email: $email, password: $password, remember: $remember }
        ) {
            account {
                id
                databaseId
                type
                name
                createdAt
            }
            user {
                firstName
                lastName
                email
                locale
                lastVisitedEnvironment
            }
            redirectUrl
            userErrors {
                field
                message
            }
        }
    }
`

export const MAGIC_LINK_MUTATION = gql`
    mutation sendMagicLinkNotification($email: String!) {
        sendMagicLinkNotification(email: $email)
    }
`

export const LOGOUT_MUTATION = gql`
    mutation logoutMutation {
        logout {
            success
        }
    }
`

export const RECOVER_MUTATION = gql`
    mutation recoverMutation($email: String!) {
        recover(input: { email: $email }) {
            success
            userErrors {
                field
                message
            }
        }
    }
`

export const RETAILER_CREATE_MUTATION = gql`
    mutation retailerCreateMutation(
        $city: String
        $cocNumber: String
        $companyName: String
        $country: CountryCode!
        $creditsafeId: String
        $email: String!
        $houseNumber: String
        $password: String!
        $postalCode: String
        $registeredCompanyName: String
        $street: String
        $vatNumber: String
        $ticaToken: String
        $ticaCardNumber: String
        $buyerAssociationMemberCode: String
        $buyerAssociationId: String
        $signupIntent: String
        $ticaRetailerNumber: String
        $dropshippingStorefrontId: ID
    ) {
        retailerCreate(
            input: {
                city: $city
                cocNumber: $cocNumber
                companyName: $companyName
                country: $country
                creditsafeId: $creditsafeId
                email: $email
                houseNumber: $houseNumber
                password: $password
                postalCode: $postalCode
                registeredCompanyName: $registeredCompanyName
                street: $street
                vatNumber: $vatNumber
                ticaToken: $ticaToken
                ticaCardNumber: $ticaCardNumber
                buyerAssociationId: $buyerAssociationId
                buyerAssociationMemberCode: $buyerAssociationMemberCode
                signupIntent: $signupIntent
                ticaRetailerNumber: $ticaRetailerNumber
                dropshippingStorefrontId: $dropshippingStorefrontId
            }
        ) {
            account {
                id
                name
                approvalStatus
                databaseId
                userId
                createdAt
                type
                country
                isTicaAccount
            }
            skipSignup
            clientMutationId
            userErrors {
                field
                message
                failed
            }
        }
    }
`

export const PASSWORD_UPDATE_MUTATION = gql`
    mutation passwordUpdateMutation(
        $currentPassword: String
        $password: String
        $passwordConfirmation: String
    ) {
        passwordUpdate(
            input: {
                current_password: $currentPassword
                password: $password
                password_confirmation: $passwordConfirmation
            }
        ) {
            clientMutationId
            message
            success
            userErrors {
                field
                message
            }
        }
    }
`
